import { useEffect, useState } from 'react';
import { ClarityHandler } from './clarityTracker';

const ConsentBanner = ({ userId, email }: { userId?: string; email?: string }) => {
    const [showBanner, setShowBanner] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('clarity_consent');
        if (!consent) {
            setShowBanner(true);
            setTimeout(() => setIsVisible(true), 100);
        }
    }, []);

    const handleConsent = () => {
        setIsVisible(false);
        setTimeout(() => {
            ClarityHandler.handleUserConsent(true, userId, email);
            setShowBanner(false);
        }, 300);
    };

    if (!showBanner) return null;

    return (
        <div 
            className={`fixed bottom-5 left-5 right-5 z-50 transition-all duration-500 ease-out 
                backdrop-blur-[0.625rem] shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.10)] 
                rounded-2xl overflow-hidden 
                ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}
        >
            <div className="p-6 rounded-2xl bg-indigo-100">
                <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between">
                    <div className="flex items-center flex-1 gap-4">
                        <div className="flex-1 flex flex-col gap-[0.625rem] text-gray-700">
                            <div className="text-lg leading-6 font-semibold">Cookie Consent</div>
                            <div className="text-base leading-5 md:text-base">
                                <p>
                                    We use cookies to improve your experience. Do you consent to the use of cookies for analytics.
                                </p>
                                <a 
                                    href="/privacy-policy" 
                                    className="inline-flex items-center gap-1 text-indigo-600 transition-colors group"
                                >
                                    Learn more about our privacy policy.
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='flex h-[2.375rem] md:self-end'>
                        <button
                            onClick={handleConsent} 
                            className='w-[7.5rem] h-full rounded-md bg-indigo-600 text-sm font-medium text-white hover:bg-indigo-700'
                        >
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentBanner;
